export default __webpack_public_path__ + "static/mars-3d8cab1f1908a20ab264cf82ae7d2cce.png";